<template>
  <div id="app" class="homepage" style="overflow:hidden">
    <!-- This section can be used to show notifications -->
    <!-- <b-alert @dblclick="showWarning = false" v-model="agreeForLogout" variant="danger" show class="m-0 p-1 text-center">
      <i class="fal fa-bullhorn"></i>
      Users are strictly requested to logout of the system at the end of the day (EOD) or after using the software, those failing to do so will be considered fatal.
    </b-alert> -->
    <b-modal v-model="showWarning" hide-header centered hide-footer>
     <div class="text-center">
        <i class="fal fa-alarm-clock mb-4" style="font-size:30px"></i>
        <h5>You are inactive for 8 mins, please move your mouse to wake up.</h5>
     </div>
    </b-modal>
    <homepage />
  </div>
</template>

<script>
import homepage from "./components/homepage/homepage";
export default {
  name: "App",
  data: ()=> {
    return {
      events: ['click','mousemove','mousedown','scroll','keypress','load'],
      logoutTimer: null,
      offline : false,
      showWarning: false,
      agreeForLogout: true
    }
  },
  mounted() {
    this.events.forEach(x=>{
      window.addEventListener(x, this.resetTimer)
    })
  },
  destroyed() {
    this.events.forEach(x=>{
      window.removeEventListener(x, this.resetTimer)
    })
    this.setTimer()
  },
  components: {
    homepage,
  },
  created() {
   
  },
  methods: {
    setTimer(){
      if(this.offline) {
        this.$store.dispatch('switchUser', {
          online: 1
        })
        this.offline = false
        this.showWarning = false
      }
      this.logoutWarningTimer = setTimeout(this.logoutWarning, 8 * 60 * 1000) // trigger offline over inactivity in 5 minutes
      this.logoutTimer = setTimeout(this.logoutAction, 10 * 60 * 1000) // trigger offline over inactivity in 5 minutes
    },
    logoutAction() {
      this.offline = true
      this.$store.dispatch('switchUser', {
        online: 0,
        notify: true
      })
    },
    logoutWarning() {
      this.showWarning = true
    },
    resetTimer(){
      clearTimeout(this.logoutTimer)
      clearTimeout(this.logoutWarningTimer)
      this.setTimer()
    }
  },
  computed: {}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700;900&display=swap');
#app{
 font-family: 'Source Sans Pro', sans-serif;
 font-weight: 600;
 font-size: 15px;
 -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}
.loading-overlay {
  position: absolute;
  width: 100%;
  margin: 10% 0;
  color: #7b72ff;
}
.b-table-sticky-header {
    overflow-y: auto;
    max-height: 500px !important;
}
.table.b-table > tbody > .table-active, .table.b-table > tbody > .table-active > th, .table.b-table > tbody > .table-active > td {
  background-color: rgba(223, 244, 247, 0.6) !important;
  border-top: none !important;
}
.table th, .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 0px !important;
}
.table thead tr{
  border-bottom: 1px solid rgb(239, 239, 239) !important;
}
.table-active > td:hover {
    background-color: rgba(223, 244, 247, 0.8) !important;
}
</style>
